
  import { css } from 'lit';
export default css`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
/* Apply proper CSS for accessibly hiding elements to each component. */
.visually-hidden {
  position: absolute !important;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border-width: 0;
}
/* Apply component specific CSS */
.grid-container {

    display: grid;

    grid-auto-rows: minmax(0, 1fr);

    place-items: center;

    justify-content: center;

    gap: 2rem
}

:host ::slotted(div) {

    display: flex;

    height: 100%;

    align-items: center;

    justify-content: center;

    overflow: hidden;

    border-radius: 0.5rem;

    padding: 0.75rem
}

.cols-2 {

    grid-template-columns: repeat(1, minmax(0, 1fr))
}

@media (min-width: 768px) {

    .cols-2 {

        grid-template-columns: repeat(2, minmax(0, 1fr))
    }
}

.cols-3 {

    grid-template-columns: repeat(1, minmax(0, 1fr))
}

@media (min-width: 768px) {

    .cols-3 {

        grid-template-columns: repeat(2, minmax(0, 1fr))
    }
}

@media (min-width: 1024px) {

    .cols-3 {

        grid-template-columns: repeat(3, minmax(0, 1fr))
    }
}

.cols-4 {

    grid-template-columns: repeat(1, minmax(0, 1fr))
}

@media (min-width: 768px) {

    .cols-4 {

        grid-template-columns: repeat(2, minmax(0, 1fr))
    }
}

@media (min-width: 1024px) {

    .cols-4 {

        grid-template-columns: repeat(4, minmax(0, 1fr))
    }
}

.cols-5 {

    grid-template-columns: repeat(1, minmax(0, 1fr))
}

@media (min-width: 768px) {

    .cols-5 {

        grid-template-columns: repeat(2, minmax(0, 1fr))
    }
}

@media (min-width: 1024px) {

    .cols-5 {

        grid-template-columns: repeat(5, minmax(0, 1fr))
    }
}

.cols-6 {

    grid-template-columns: repeat(1, minmax(0, 1fr))
}

@media (min-width: 768px) {

    .cols-6 {

        grid-template-columns: repeat(2, minmax(0, 1fr))
    }
}

@media (min-width: 1024px) {

    .cols-6 {

        grid-template-columns: repeat(6, minmax(0, 1fr))
    }
}

.cols-7 {

    grid-template-columns: repeat(1, minmax(0, 1fr))
}

@media (min-width: 768px) {

    .cols-7 {

        grid-template-columns: repeat(2, minmax(0, 1fr))
    }
}

@media (min-width: 1024px) {

    .cols-7 {

        grid-template-columns: repeat(7, minmax(0, 1fr))
    }
}

.cols-8 {

    grid-template-columns: repeat(1, minmax(0, 1fr))
}

@media (min-width: 768px) {

    .cols-8 {

        grid-template-columns: repeat(2, minmax(0, 1fr))
    }
}

@media (min-width: 1024px) {

    .cols-8 {

        grid-template-columns: repeat(8, minmax(0, 1fr))
    }
}

.cols-9 {

    grid-template-columns: repeat(1, minmax(0, 1fr))
}

@media (min-width: 768px) {

    .cols-9 {

        grid-template-columns: repeat(2, minmax(0, 1fr))
    }
}

@media (min-width: 1024px) {

    .cols-9 {

        grid-template-columns: repeat(9, minmax(0, 1fr))
    }
}

.cols-10 {

    grid-template-columns: repeat(1, minmax(0, 1fr))
}

@media (min-width: 768px) {

    .cols-10 {

        grid-template-columns: repeat(2, minmax(0, 1fr))
    }
}

@media (min-width: 1024px) {

    .cols-10 {

        grid-template-columns: repeat(10, minmax(0, 1fr))
    }
}

.cols-11 {

    grid-template-columns: repeat(1, minmax(0, 1fr))
}

@media (min-width: 768px) {

    .cols-11 {

        grid-template-columns: repeat(2, minmax(0, 1fr))
    }
}

@media (min-width: 1024px) {

    .cols-11 {

        grid-template-columns: repeat(11, minmax(0, 1fr))
    }
}

.cols-12 {

    grid-template-columns: repeat(1, minmax(0, 1fr))
}

@media (min-width: 768px) {

    .cols-12 {

        grid-template-columns: repeat(2, minmax(0, 1fr))
    }
}

@media (min-width: 1024px) {

    .cols-12 {

        grid-template-columns: repeat(12, minmax(0, 1fr))
    }
}
`;